export * from './insurer-footer.component';
